import { ProtectedImg } from '../../utils/protectedFile';
import React, {useState, useEffect, Fragment} from 'react';
import { searchOnEnter } from '../../components/searchOnEnter';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import MetaData from '../../layouts/MetaData';
import defaultImg from '../../assets/Images/defaultUser.png';
import {Link} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getHRPatients } from '../../actions/HRActions';
import { removePatientsHR, removeDoctorFromHR } from '../../actions/adminActions';
import { useAlert } from 'react-alert';
import folderImg from '../../assets/Images/folder.png';
import {Badge, Table, Modal, Button, DropdownButton, Dropdown } from 'react-bootstrap';
import { Prod01 } from '../../constants/ActionType';
import { formatClinicianName } from '../../utils/clinicianName';
import NurseCareTeamPatients from '../../components/CareTeam/NurseCareTeamPatients';
import { useSortableTable, SortableTh, personName } from '../../components/SortableTable';
import { formatDateTime, formatDob } from '../../utils/dateFormat';

const NURSE_PATIENT_SORT_COLUMNS = {
    name: { type: 'name', value: personName },
    dob: { type: 'date', value: (p) => p?.DOB },
    status: { type: 'boolean', value: (p) => p?.block },
    provider: { type: 'name', value: (p) => personName(p?.assigned_doctor_id) },
    compliancy: { type: 'number', value: (p) => (p?.assigned_devices || []).length },
    consent: { type: 'string', value: (p) => p?.patientType },
};


const HRProfile = (props) => {

  const dispatch = useDispatch();
  const alert = useAlert();

  let hrInfo = props?.location?.state?.hr;
  let doctor = props?.location?.state?.hr?.assigned_doctor_id;
  let id = hrInfo?._id;


  const [smShow, setSmShow] = useState(false); //small confirm modal.
  const [patientName, setPatientName] = useState(""); //patient name to show in modal.
  const [patientToRemove, setpatientToRemove] = useState(""); //set patient id to remove.
  const [hrId, setHrId] = useState(id); 
  const [doctorDetails, setDoctorDetails] = useState(doctor); 
  const [hrDetails, setHrDetails] = useState(hrInfo);
  const [query, setQuery] = useState("");
  const [tab, setTab] = useState("patients");
  const keys = ["firstname", "lastname", "DOB", "email", "phone1"];

  const { hrpatients} = useSelector(state => state.hrPatients);
  const tableSort = useSortableTable(hrpatients, { id: 'admin.nurseProfile.patients', columns: NURSE_PATIENT_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });
  const {error, message} = useSelector(state => state.common);

  useEffect(() => {
    if(message){
        alert.success(message);
    }

    if(error){
        alert.error(error)
    }

    if(doctor?._id){
        dispatch(getHRPatients(doctor._id));
    }

  },[dispatch, alert, error, message])


  const removePatient = () => {
    dispatch(removePatientsHR(patientToRemove));
    setSmShow(false);
    }

  const removeDoctor = () => {
    var confirmation = window.confirm(`Are you sure you want to remove doctor from ${hrDetails?.firstname} `);
    if(confirmation === true) {
        dispatch(removeDoctorFromHR(hrId, doctor._id));
        setDoctorDetails("");
        return;
    }  
  }

  const sendEmail = (email) => {
    window.open(`mailto:${email}`)
  }

  return <Fragment>
      <MetaData title={ hrDetails?.firstname +" "+ hrDetails?.lastname }/>
        <Sidebar />    

        <section className="home-section">
        {/* TopBar */}
        <TopBar />

        <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded">
            <div className="home-content">

            <div className="row-display">
                    <div className="col-md-6">   
                        <h5 className='title'>
                            <i className="bx bx-user"></i> <strong>&nbsp;Nurse Profile </strong>
                        </h5>
                    </div>
                    
                    <div className="row-display">
                            <Button className="btn btn-secondary btn-sm" onClick={() => props.history.goBack()}><i className='bx bx-arrow-back' ></i></Button> &nbsp;
                            
                            <Link to="/adminDashboard" className="btn btn-secondary btn-sm"><i className='bx bx-home'></i></Link> &nbsp;
                            
                            
                            <Link to={{ pathname: "/assignPatientToHr", state: {id: hrDetails}}} 
                                className="edit-pill" title="Classic one-at-a-time screen; the Patients tab below can add many at once">Assign patient (classic)
                            </Link>

                            &nbsp;
                            {hrDetails?.assigned_doctor_id ? ' ' : <>
                            <Link to={{ pathname: "/assignDrToHr", state: {id: hrDetails}}} 
                                className="add-staff-btn">Assign Provider
                            </Link>
                        </>}
                    </div>                          
                </div>
                <hr />

                <ul className="nav nav-tabs mb-3" role="tablist">
                  <li className="nav-item"><button type="button" role="tab" aria-selected={tab === "patients"} className={`nav-link ${tab === "patients" ? "active" : ""}`} onClick={() => setTab("patients")}>Patients</button></li>
                  <li className="nav-item"><button type="button" role="tab" aria-selected={tab === "profile"} className={`nav-link ${tab === "profile" ? "active" : ""}`} onClick={() => setTab("profile")}>Profile</button></li>
                </ul>
                {tab === "patients" && <NurseCareTeamPatients nurseId={hrDetails?._id} />}
                <div hidden={tab !== "profile"}>
                <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className='text-center'>
                                {hrDetails && hrDetails?.profileImg ? <>
                                    <ProtectedImg fileName={hrDetails?.profileImg} 
                                    className="profile-img" alt="profileimg" 
                                />
                                </> :  <img src={defaultImg} className="profile-img" alt="profileimg" 
                                />}    

                                    <p className="profile-name"> {hrDetails?.lastname}, {hrDetails?.firstname} </p>
                                    
                                    <Link to="/hrProfile" 
                                        className="link text-center" 
                                        onClick={() => sendEmail(hrDetails?.email)}><p className="text-center">{hrDetails?.email}</p>
                                    </Link>

                                    <Link className="edit-pill" to={{pathname: "/updateHR", state:{ hr: hrDetails}}}>
                                        Edit Profile
                                    </Link>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div>
                                    <div className="card-inner-margin">
                                        <div className="row">
                                        <div className="col-md-6">

                                            <span className="profile-label">Account Status: </span>
                                            {hrDetails?.block === false ? <td>
                                                <span style={{color: 'green', fontWeight: 'bold'}}>Active</span>
                                                </td> : <td><span style={{color: 'red', fontWeight: 'bold'}}>Inactive</span>
                                            </td>}
                                            <br/>

                                            <span className="profile-label">Gender: </span>
                                            <p className="profile-value-text">
                                                {hrDetails.gender}
                                            </p>                            
                                            
                                            <span className="profile-label">Mobile No: </span>
                                                <p className="profile-value-text">{hrDetails?.mobileNo ? <span><i className='bx bx-phone'></i> {hrDetails?.mobileNo} </span> : '--'}</p>
                                            </div>


                                            <div className="col-md-6">
                                                <span className="profile-label">DOB : </span>
                                                <p className="profile-value-text">{formatDob(hrDetails?.DOB)}</p>

                                                <span className="profile-label">Phone 1: </span>
                                                <p className="profile-value-text">{hrDetails?.phone1 ? <span><i className='bx bx-phone'></i> {hrDetails?.phone1} </span> : '--'}</p>                                            
                                                
                                                <p className="profile-label">Account Created At: </p>
                                                <p className="profile-value-text">{formatDateTime(hrDetails?.createdAt)}</p>
                                            </div>

                                            <div className="col-md-4">
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                {/* <h5 style={{color: '#004aad', marginTop: '10px', textAlign: 'center'}}>
                                    <i className="bx bx-user"></i> <strong>&nbsp;Assigned Doctor </strong>
                                </h5> */}
                                {doctorDetails ? doctorDetails && <>
                                    <div className='text-center'>
                                    
                                    {doctorDetails?.profileImg ? <>
                                    <ProtectedImg fileName={doctorDetails?.profileImg} 
                                        className="profile-img" alt="profileimg" 
                                    />
                                    </> :  <img src={defaultImg} className="profile-img" alt="profileimg" 
                                    />}
                                    
                                    
                                    
                                    <p className="profile-name">Nurse for {formatClinicianName(doctorDetails)} </p>
                                    <p className="profile-value-text text-center">{doctorDetails?.email}</p>
                                    <button className="edit-pill" onClick={removeDoctor}>Remove Provider</button>
                                    </div>
                                    </> : <small style={{color: 'gray'}}>No provider assigned yet</small>}
                            </div>
                        </div>  

                        <hr />  
                        {/* HRs Patients List */}
                        <div className="row-display">
                            <h5 style={{color: '#004aad', marginTop: '10px'}}>
                                <i className="bx bxs-user-check"></i> <strong>&nbsp;Patients List ({hrpatients && hrpatients?.length < 10 ? '0'+hrpatients?.length : hrpatients?.length})</strong>
                                <p><small>Patients of your assigned doctor will be listed below.</small></p>
                            </h5>
                            

                            <div className="row-display"> 
                            <input 
                                type="text" 
                                className="form-control mt-2"
                                onChange={e => setQuery(e.target.value)}
                                onKeyDown={searchOnEnter(setQuery)}
                                placeholder="Search"
                                style={{width: '180px', height: '40px'}}
                            /> 

                            &nbsp;&nbsp;&nbsp;
                            </div>
                            </div>
                        
                        
                        {hrpatients?.length > 0 ? (<>
                                <div className="col-md-12">
                                    <>
                                        <Table responsive className="table table-sm table-striped">
                                        <thead align="center">
                                            <tr>
                                                <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                                <SortableTh sortKey="dob" sort={tableSort}>D.O.B</SortableTh>
                                                <SortableTh sortKey="status" sort={tableSort}>Account Status</SortableTh>
                                                <SortableTh sortKey="provider" sort={tableSort}>Assigned Provider</SortableTh>
                                                <SortableTh sortKey="compliancy" sort={tableSort}>Compliancy Status</SortableTh>
                                                <th>Diseases</th>
                                                <SortableTh sortKey="consent" sort={tableSort}>Consent Program</SortableTh>
                                                <th>Action</th>
                                            </tr> 
                                        </thead>
                                        <tbody>
                                        {tableSort.rows.filter(item => keys.some(key => item[key]?.toLowerCase().includes(query))).map((patient, index) => ( 
                                            <tr key={index}>
                                            
                                        {patient?.block === false ?  <td><Link className="link" to={{ pathname: "/patientProfile", state: {patientid: patient?._id, deviceid: patient?.deviceassigned?.deviceid}}}>
                                                {patient?.lastname}, {patient?.firstname}
                                                </Link>
                                            </td> : <td>
                                                {patient?.lastname}, {patient?.firstname} 
                                            </td> }

                                            <td> {formatDob(patient?.DOB)} <p>{patient?.gender}</p></td> 

                                            <td>
                                                {patient?.block === false ? <span style={{color: 'green', fontWeight: 'bold'}}>Active</span> : <span style={{color: 'red', fontWeight: 'bold'}}>Deactivated</span> }   
                                             </td>    
                                            

                                            {patient?.assigned_doctor_id ? <>
                                                <td className="text-nowrap">{formatClinicianName(patient?.assigned_doctor_id)}</td>
                                                </> : <>
                                                <td>--</td>
                                            </>}

                                            <td>
                                                {patient?.assigned_devices.length > 0 ? <Badge 
                                                pill bg="success text-white" style={{fontSize: '12px'}}>compliant</Badge> : 
                                                <Badge pill bg="danger text-white" style={{fontSize: '12px'}}>non-compliant</Badge>}
                                            </td>

                                            <td className='shrinkText'>{patient?.diseases}</td>

                                            <td>{patient.patientType}</td>
                                            
                                            <td>
                                                <DropdownButton id="dropdown-basic-button" variant="Light" disabled={patient?.block === true ? true : true}>
                                                    <Dropdown.Item>
                                                        <Link to={{ pathname: "/patientProfile", state: {patientid: patient?._id}}} className="link">View Profile</Link> &nbsp;
                                                    </Dropdown.Item>

                                                    <Dropdown.Item>
                                                        <Link to="/hrProfile" className="link" style={{color: 'red'}} onClick={() => {setSmShow(true); setPatientName(patient?.lastname); setpatientToRemove(patient?._id)}}>Remove from list</Link> &nbsp;
                                                    </Dropdown.Item>
                                                </DropdownButton>
                                            </td>
                                        </tr> 
                                        
                                        ))}
                                        
                                        </tbody>
                                        </Table>    
                                            </>                      
                                          </div>
                                        </> ) : <>
                                        <div>   
                                           
                        <img src={folderImg} className="no-record-found-img"/>
                        <p className="doctor-specilizations">No Patient Assigned Yet...</p>                            
                                    </div>
                                </> }
                      </div>
                </div>
                    </div>
                </div>
       </section>

       {/* Modal to delete HR Patient */}
       <Modal
        size="sm"
        show={smShow}
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
        >
            <Modal.Body>
                <small style={{color: '#303030'}}>Are you sure you want to remove patient 
                        <span style={{color: '#303030', fontWeight: 'bold'}}> {patientName}</span> from hr ?
                </small>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-sm btn-danger" onClick={removePatient}>Remove</button>
            </Modal.Footer>
            </Modal> 
        </Fragment>;
};

export default HRProfile;
